import { withInstall } from '@/utils'
import GcCodeSelect from './src/gcCodeSelect.vue'
export default withInstall(GcCodeSelect)
